import { TooltipCommonProps } from '../../common';

export type EllipsisProps = EllipsisCommonProps & {
  render(renderProps: RenderProps): React.ReactElement;
  wrapperClassName?: string;
};

export type EllipsisCommonProps = TooltipCommonProps & {
  ellipsis?: boolean;
  showTooltip?: boolean;
  maxLines?: number;
  onEllipsisStateChange?: (isActive: boolean) => void;
};

export type EllipsisState = {
  isActive: boolean;
  textContent: string | null;
  textRendered: boolean;
};

export type RenderChildrenParams = {
  text: React.ReactNode;
  suffix?: React.ReactNode;
};

export type RenderElementParams = {
  element: React.ReactNode;
  suffix?: React.ReactNode;
};

export type RenderProps = {
  ref: React.RefObject<any>;
  ellipsisClasses: (className?: string) => string;
  ellipsisInlineStyle?: React.CSSProperties;
  renderChildren: ({ text, suffix }: RenderChildrenParams) => React.ReactNode;
  renderElement: ({ element, suffix }: RenderElementParams) => React.ReactNode;
};
